var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"common-employee-details-modal","title":"Manage Holiday","hide-footer":""}},[_c('HolidaySettingsEditForm',{attrs:{"holiday":_vm.selectedHoliday},on:{"form-success":_vm.handleSuccess,"form-failure":_vm.handleFailure}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }